/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_400Inputs */

const vi_carrier_status_400 = /** @type {(inputs: Carrier_Status_400Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khai thác đến`)
};

/**

* @param {Carrier_Status_400Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_400 = /** @type {((inputs?: Carrier_Status_400Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_400Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_400(inputs)
});